import { AGENTS, QUEUES, QUEUE_STATS } from "../types";

export const agentsAction = agents => {
  return {
    type: AGENTS,
    payload: agents,
  };
};

export const queuesAction = queues => {
  return {
    type: QUEUES,
    payload: queues,
  };
};

export const queueStatsAction = queueStats => {
  return {
    type: QUEUE_STATS,
    payload: queueStats,
  };
};
